import { Button as AntdButton } from 'antd'
import React from 'react'
import styled, { css } from 'styled-components'
import { COLORS } from 'theme'
import Flex from '../Flex'
const BorderStyle = css`
  &:hover {
    border-color: ${COLORS.GREY_T_85};
  }
  &:focus {
    border-color: ${COLORS.GREY_T_85};
  }
`
const PrimaryButtonStyles = css`
  background-color: #3249d7;
  color: #f9fafe;
  &:hover {
    background-color: #3249d7;
    color: #f9fafe;
  }
  &:focus {
    background-color: #3249d7;
    color: #f9fafe;
  }
`
const TextContainer = styled.div`
  margin-left: ${props => (props.icon ? '7px' : '')};
`
const dangerButtonStyles = css`
  background-color: ${COLORS.RED_T_90};
  border-color: ${COLORS.RED_T_20};
  color: ${COLORS.RED_S_100};
  &:hover {
    background-color: ${COLORS.RED_T_90};
    border-color: ${COLORS.RED_T_20};
    color: ${COLORS.RED_S_100};
  }
  &:focus {
    background-color: ${COLORS.RED_T_90};
    border-color: ${COLORS.RED_T_20};
    color: ${COLORS.RED_S_100};
  }
  ${props =>
    props.disable &&
    css`
      background-color: #f1f1f1;
      border-color: #d1d5db;
      color: #b8b8b8;
      cursor: not-allowed;
      pointer-events: none;
    `}
`
const secondaryButtonStyles = css`
  border-color: ${props => (props.isBorder ? '#3249D7' : 'blue')} !important;
  background-color: ${COLORS.PRIMARY_PURPLE};

    props.isBorder ? '#3249D7' : COLORS.PURPLE_T_80};
  color: '#FFFFFF';
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  &:hover {
    background-color: ${COLORS.PRIMARY_PURPLE};
    border-color: ${COLORS.PURPLE_T_80};
  }
  &:focus {
    background-color: ${COLORS.PRIMARY_PURPLE};
    border-color: ${COLORS.PURPLE_T_80};
  }
  font-weight: bold;
`
const defaultButtonStyles = css`
  color: #30475e;
`

const PlainButton = styled(AntdButton)`
  width: ${props => (props.width ? props.width : '')};
  height: ${props => (props.height ? props.height : '40px')};
  color: ${props => (props.type === 'secondary' ? COLORS.PRIMARY : '#FFFFFF')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: ${props => (props.radius ? props.radius : '8px')};
  justify-content: center;
  cursor: ${props => props?.disableCursor && 'not-allowed'};
  opacity: ${props => (props?.disabled ? '0.5' : '1')};
  pointer-events: ${props => (props?.disable ? 'none' : 'auto')};
  ${props => props.type === 'primary' && PrimaryButtonStyles};
  ${props => props.type === 'secondary' && secondaryButtonStyles}
  ${props => props.type === 'danger' && dangerButtonStyles};
  ${props => props.type === 'default' && defaultButtonStyles};
  ${props => props.dashed && 'border-style: dashed;'}
  ${BorderStyle}
`
const CircleButton = styled(AntdButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  ${props => props.dashed && 'border-style: dashed;'}
  background: ${props => (props.background ? props.background : '')};
  ${BorderStyle}
`

const Button = props => <AntdButton {...props} />

const Primary = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="primary">
    {icon}
    <TextContainer icon={Boolean(icon)}>{text}</TextContainer>
  </PlainButton>
)

const Secondary = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="secondary">
    {icon}
    {text && <TextContainer icon={Boolean(icon)}>{text}</TextContainer>}
  </PlainButton>
)

const Danger = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="danger">
    {icon}
    <TextContainer icon>{text}</TextContainer>
  </PlainButton>
)

const Default = ({ icon, text, onClick, ...rest }) => {
  return (
    <PlainButton onClick={onClick} {...rest} type="default">
      {icon}
      <TextContainer icon={icon}>{text}</TextContainer>
    </PlainButton>
  )
}

const Round = ({ icon, text, onClick, ...rest }) => {
  return (
    <PlainButton type="round" onClick={onClick} {...rest}>
      {icon}
      <TextContainer>{text}</TextContainer>
    </PlainButton>
  )
}

const Circle = ({ icon, onClick, ...rest }) => {
  return (
    <CircleButton type="circle" onClick={onClick} {...rest}>
      {icon}
    </CircleButton>
  )
}

const Outline = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="outline">
    <Flex>
      <TextContainer>{text}</TextContainer>
    </Flex>
  </PlainButton>
)

Button.Primary = Primary
Button.Secondary = Secondary
Button.Danger = Danger
Button.Default = Default
Button.Round = Round
Button.Outline = Outline
Button.Circle = Circle

export default Button
